<template>
  <div id="app">
    <router-view />
    <!-- <router-view v-wechat-title="$route.meta.title"  /> -->
    
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    document.title = this.$route.meta.title;
  }
}
</script>

<style>
#app {
  font-family: "PingFangSC-Semibold", "PingFang SC", "微软雅黑", "宋体", Arial, Helvetica, sans-serif,'Avenir';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;

}
html,body{
  height: 100%;
  overflow: scroll;
}
</style>



// WEBPACK FOOTER //
// src/App.vue